import { createContext, PropsWithChildren } from 'react';
import ReactModal from 'react-modal';
import { PopupModalTheme, PopupModal, PopupModalProps } from '../popupmodals';
import ButtonPanel from '../popupmodals/buttonpanel';
import { useWindowWidth } from '../useWindowWidth';

const styles = ({
  isLg,
  variant = 'small',
  position,
  hideBackdrop,
  height,
}: {
  isLg: boolean;
  variant: 'small' | 'large';
  position: 'center' | 'bottom-right';
  hideBackdrop: boolean;
  height?: string;
}) => {
  const mobile = !isLg;
  const customStyles: ReactModal.Styles = {
    content: {
      maxHeight: '91vh',
      height: height || 'auto',
      maxWidth: mobile ? '100%' : variant === 'large' ? '90%' : '700px',
      padding: '0px',
      inset:
        position === 'center' ? (mobile ? 'auto 0 0' : '') : mobile ? 'auto 16px 16px auto' : 'auto 40px 40px auto',
      borderRadius: '8px',
      overflowY: 'hidden',
    },
    overlay: {
      background: hideBackdrop ? '' : 'rgba(0,0,0,0.25)',
      display: 'grid',
      placeItems: 'center',
      zIndex: '1000',
    },
  };
  return customStyles;
};

export const ModalThemeContext = createContext<PopupModalTheme | null>(null);

const ModalMain = ({
  children,
  isOpen = false,
  variant = 'small',
  closeModal,
  position = 'center',
  hideBackdrop = false,
  shouldCloseOnEsc,
  height,
  ...props
}: PropsWithChildren<
  Omit<PopupModalProps, 'onClose'> & {
    closeModal?: () => void;
    isOpen?: boolean;
    onClose?: () => void;
    variant?: 'small' | 'large';
    position?: 'center' | 'bottom-right';
    hideBackdrop?: boolean;
    shouldCloseOnEsc?: boolean;
    height?: string;
  }
>) => {
  const { isLg } = useWindowWidth();

  return (
    <ModalThemeContext.Provider value={props.theme || 'primary'}>
      <ReactModal
        isOpen={isOpen}
        style={styles({ isLg, variant, position, hideBackdrop, height })}
        ariaHideApp={false}
        shouldCloseOnEsc={shouldCloseOnEsc}
      >
        <PopupModal {...props} onClose={closeModal}>
          {children}
        </PopupModal>
      </ReactModal>
    </ModalThemeContext.Provider>
  );
};

export const Modal = Object.assign(ModalMain, {
  ButtonPanel,
});
